/**
 * Deduplicates identical in-flight API calls and optionally serves fresh
 * short-TTL cache to avoid hammering the backend (429) on mount / Strict Mode.
 */

const inflight = new Map();
const cache = new Map();

export function clearApiCacheEntry(key) {
  cache.delete(key);
  inflight.delete(key);
}

/**
 * @param {string} key
 * @param {number} ttlMs - cached successful responses only (status 200)
 * @param {() => Promise<any>} factory
 */
export function cachedRequest(key, ttlMs, factory) {
  const now = Date.now();
  const hit = cache.get(key);
  if (hit && hit.expires > now) {
    return Promise.resolve(hit.value);
  }
  if (inflight.has(key)) {
    return inflight.get(key);
  }
  const promise = factory()
    .then((value) => {
      if (value && value.status === 200) {
        cache.set(key, { expires: Date.now() + ttlMs, value });
      }
      return value;
    })
    .finally(() => {
      inflight.delete(key);
    });
  inflight.set(key, promise);
  return promise;
}
